var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "border-b border-gray-200 bg-gray-600 rounded-t-md px-4 py-1",
    },
    [
      _c(
        "h4",
        { staticClass: "leading-6 text-base font-bold text-gray-100" },
        [_vm._t("default")],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }